<template>
	<div>
        <div class="card-body">
            <a target="_blank" class="btn btn-lg btn-primary m-4" :href="'/user_dataset?dataset=appended-' + this.passedData +
            '.csv&format=raw&objid=null'" :download="'appended-' + this.passedData +
            '.csv'"><i class="fas fa-download"></i> Download Appended File</a>      
        </div>
    </div>
</template>
<script>
export default {
    props: {
        passedData: {
        type: String,
        default() {
            return 'Dataset'
        }
        }
    },
}
</script>